import { render } from "./Barracks.vue?vue&type=template&id=581fed86"
import script from "./Barracks.vue?vue&type=script&lang=js"
export * from "./Barracks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Barracks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "581fed86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('581fed86', __exports__)) {
    api.reload('581fed86', __exports__)
  }
  
  module.hot.accept("./Barracks.vue?vue&type=template&id=581fed86", () => {
    api.rerender('581fed86', render)
  })

}


export default __exports__